<form class="row g-2" novalidate [formGroup]="vehicleForm" (ngSubmit)="next()">
    <div class="col-sm-6">
        <label class="col-12 form-label m-0" for="vehicle_search">Búsqueda (NIV, Placa o N/S)</label>
        <div class="col-12 input-group">
            <input class="form-control" id="vehicle_search" type="text" [ngModel]="searchNiv"
                (ngModelChange)="searchNiv = $event" [ngModelOptions]="{standalone: true}" placeholder="..."
                aria-describedby="button-addon2">
            <button id="button-addon2" type="button" class="btn btn-outline-dark"
                (click)="findVehicle()">Buscar</button>
        </div>
    </div>
    <div class="col-sm-6">
        <label class="col-12 form-label m-0" for="vehicle_niv">NIV Asignado</label>
        <div class="col-12 custom-input">
            <input class="form-control bg-light" id="vehicle_niv" type="text" formControlName="niv" readonly
                placeholder="(Autogenerado)">
        </div>
    </div>
    <div class="col-6">
        <label class="col-12 form-label m-0" for="vehicle_plate">Placas <span class="txt-danger"> *</span></label>
        <div class="col-12 custom-input">
            <input class="form-control" type="text" id="vehicle_plate" aria-label="($MXN)" formControlName="plates"
                [ngClass]="{ 'is-invalid' : (vehiclePlate?.touched || validate) && vehiclePlate?.errors, 'is-valid' : !vehiclePlate?.errors}">
            @if (vehiclePlate?.errors) {
            <div class="invalid-feedback">Ingrese las placas del vehículo.</div>
            }
        </div>

        <!--<div class="custom-input">
            <input class="form-control is-invalid" id="vehicle_plate" type="text" formControlName="plate"
                   [ngClass]="{ 'is-invalid' : (vehiclePlate?.touched || validate) && vehiclePlate?.errors, 'is-valid' : !vehiclePlate?.errors}">
            @if (vehiclePlate?.errors) {
                <div class="invalid-feedback">Ingrese las placas del vehículo.</div>
            }
        </div>-->
    </div>
    <!-- NIV
    <div class="col-sm-6">
        <label class="col-12 form-label m-0" for="vehicle_niv">NIV</label>
        <div class="col-12 custom-input">
            <input class="form-control" id="vehicle_niv" type="text" formControlName="niv">
        </div>
    </div>-->
    <!-- Serial Number -->
    <div class="col-sm-6">
        <label class="col-12 form-label m-0" for="vehicle_ns">Número de serie</label>
        <div class="col-12 custom-input">
            <input class="form-control" id="vehicle_ns" type="text" formControlName="ns">
        </div>
    </div>
    <!-- year -->
    <div class="col-sm-2">
        <label class="col-12 form-label m-0" for="vehicle_year">Año <span class="txt-danger"> *</span></label>
        <div class="col-12 custom-input">
            <input class="form-control" id="vehicle_year" type="number" formControlName="year"
                [ngClass]="{ 'is-invalid' : (vehicleYear?.touched || validate) && vehicleYear?.errors, 'is-valid' : !vehicleYear?.errors}">
            @if (vehicleYear?.errors) {
            <div class="invalid-feedback">Ingrese las año del vehículo.</div>
            }
        </div>
    </div>
    <!-- brand -->
    <div class="col-sm-5">
        <label class="col-12 form-label m-0" for="vehicle_brand">Marca <span class="txt-danger"> *</span></label>
        <select class="col-12 form-select" id="vehicle_brand" required formControlName="brandId"
            (change)="onSelectSubBrand($event)"
            [ngClass]="{ 'is-invalid' : (vehicleBrand?.touched || validate) && vehicleBrand?.errors, 'is-valid' : !vehicleBrand?.errors}">
            <option [ngValue]="null" disabled selected>Marca</option>
            <option *ngFor="let brand of vehicleBrandlist" [value]="brand.id">{{ brand.value }}</option>
        </select>
        @if (vehicleBrand?.errors) {
        <div class="invalid-feedback">Selecciona la marca del vehículo</div>
        }
    </div>
    <!-- subBrand -->
    <div class="col-sm-5">
        <label class="col-12 form-label m-0" for="vehicle_subbrand">Submarca <span class="txt-danger"> *</span></label>
        <select class="col-12 form-select" id="vehicle_subbrand" required formControlName="subBrandId"
            [ngClass]="{ 'is-invalid' : (vehicleSubbrand?.touched || validate) && vehicleSubbrand?.errors, 'is-valid' : !vehicleSubbrand?.errors}">
            <option [ngValue]="null" disabled selected>Submarca</option>
            <option *ngFor="let subbrand of vehicleSubbrandist" [value]="subbrand.id">{{ subbrand.value }}</option>
        </select>
        @if (vehicleSubbrand?.errors) {
        <div class="invalid-feedback">Selecciona la marca del vehículo</div>
        }
        <p class="f-light">Debe seleccionar una marca</p>
    </div>
    <!-- categoryId -->
    <div class="col-sm-4">
        <label class="col-12 form-label m-0" for="vehicle_category">Categoría </label>
        <select class="col-12 form-select" id="vehicle_category" required formControlName="categoryId">
            <option [ngValue]="null" disabled selected>Categoría</option>
            <option *ngFor="let version of vehicleCategoryist" [value]="version.id">{{ version.value }}</option>
        </select>
    </div>
    <!-- version -->
    <div class="col-sm-4">
        <label class="col-12 form-label m-0" for="vehicle_version">Versión </label>
        <select class="col-12 form-select" id="vehicle_version" required formControlName="versionId">
            <option [ngValue]="null" disabled selected>Version</option>
            <option *ngFor="let version of vehicleVersionlist" [value]="version.id">{{ version.value }}</option>
        </select>
    </div>
    <!-- transmisiop -->
    <div class="col-sm-4">
        <label class="col-12 form-label m-0" for="vehicle_transmission">Transmisión</label>
        <select class="col-12 form-select" id="vehicle_transmission" formControlName="transmission">
            <option selected="" value="">--Selecciona uno--</option>
            <option>Manual</option>
            <option>Automatico </option>
        </select>

    </div>
    <!-- km Mtto. -->
    <div class="col-sm-2">
        <label class="col-12 form-label m-0" for="vehicle_kmMtto">km Mtto <span class="txt-danger"> *</span></label>
        <div class="col-12 custom-input">
            <input class="form-control" id="vehicle_kmMtto" type="number" formControlName="maintenanceKm"
                [ngClass]="{ 'is-invalid' : (vehicleKmMtto?.touched || validate) && vehicleKmMtto?.errors, 'is-valid' : !vehicleKmMtto?.errors}">
            @if (vehicleKmMtto?.errors) {
            <div class="invalid-feedback">El kilometraje de mtto es requerido</div>
            }
        </div>
    </div>
    <!-- color exterior -->
    <div class="col-sm-5">
        <label class="col-12 form-label m-0" for="vehicle_color">Color Exterior<span class="txt-danger">
                *</span></label>
        <div class="col-12 custom-input">
            <input class="form-control" id="vehicle_color" type="text" formControlName="color"
                [ngClass]="{ 'is-invalid' : (vehicleColor?.touched || validate) && vehicleColor?.errors, 'is-valid' : !vehicleColor?.errors}">
            @if (vehicleColor?.errors) {
            <div class="invalid-feedback">El color exterior del vehículo es requerido</div>
            }
        </div>
    </div>
    <!-- gps interior -->
    <div class="col-sm-5">
        <label class="col-12 form-label m-0" for="vehicle_interiorColor">Color Interior <span class="txt-danger">
                *</span></label>
        <div class="col-12 custom-input">
            <input class="form-control" id="vehicle_interiorColor" type="text" formControlName="interiorColor"
                [ngClass]="{ 'is-invalid' : (vehicleInteriorColor?.touched || validate) && vehicleInteriorColor?.errors, 'is-valid' : !vehicleInteriorColor?.errors}">
            @if (vehicleInteriorColor?.errors) {
            <div class="invalid-feedback">El color interior es requerido</div>
            }
        </div>
    </div>

    <!-- tag fuel -->
    <div class="col-sm-6">
        <label class="col-12 form-label m-0" for="vehicle_tagfuel">Tag combustible <span class="txt-danger">
                *</span></label>
        <div class="col-12 custom-input">
            <input class="form-control" id="vehicle_tagfuel" type="text" formControlName="fuelTag"
                [ngClass]="{ 'is-invalid' : (vehicleFuel?.touched || validate) && vehicleFuel?.errors, 'is-valid' : !vehicleFuel?.errors}">
            @if (vehicleFuel?.errors) {
            <div class="invalid-feedback">ingrese el tag de combustible</div>
            }
        </div>
    </div>
    <!-- tag foll -->
    <div class="col-sm-6">
        <label class="col-12 form-label m-0" for="vehicle_tagfoll">Tag caseta <span class="txt-danger"> *</span></label>
        <div class="col-12 custom-input">
            <input class="form-control" id="vehicle_tagfoll" type="text" formControlName="tollTag"
                [ngClass]="{ 'is-invalid' : (vehicleFoll?.touched || validate) && vehicleFoll?.errors, 'is-valid' : !vehicleFoll?.errors}">
            @if (vehicleFoll?.errors) {
            <div class="invalid-feedback">Ingrese el tag de casetas</div>
            }
        </div>
    </div>
    <!-- gps -->
    <div class="col-sm-8">
        <label class="col-12 form-label m-0" for="vehicle_gps">GPS <span class="txt-danger"> *</span></label>
        <div class="col-12 custom-input">
            <input class="form-control" id="vehicle_gps" type="text" formControlName="gps"
                [ngClass]="{ 'is-invalid' : (vehicleGps?.touched || validate) && vehicleGps?.errors, 'is-valid' : !vehicleGps?.errors}">
            @if (vehicleGps?.errors) {
            <div class="invalid-feedback">El GPS es requerido</div>
            }
        </div>
    </div>
    <!-- extintor -->
    <div class="col-sm-4">
        <label class="col-12 form-label m-0" for="vehicle_extintor">Extintor <span class="txt-danger"> *</span></label>
        <div class="col-12 custom-input">
            <select class="col-12 form-select" id="vehicle_extintor" formControlName="extintor"
                [ngClass]="{ 'is-invalid' : (vehicleExtintor?.touched || validate) && vehicleExtintor?.errors, 'is-valid' : !vehicleExtintor?.errors}">
                <option selected="" value="">--Selecciona uno--</option>
                <option value="1">Con extintor</option>
                <option value="0">Sin extintor </option>
            </select>
            @if (vehicleExtintor?.errors) {
            <div class="invalid-feedback">El GPS es requerido</div>
            }
        </div>
    </div>
    <div class="col-md-12">
        <div class="card-wrapper border rounded-3 checkbox-checked">
            <h6 class="sub-title">Equipamiento</h6>
            <div class="form-check-size" formGroupName="equipmentList">
                <div class="form-check form-check-inline checkbox checkbox-dark mb-0"
                    *ngFor="let equipment of equipmentList">
                    <input class="form-check-input" id="eq-{{equipment.id}}" type="checkbox"
                        [formControlName]="equipment.id">
                    <label class="form-check-label" for="eq-{{equipment.id}}">{{equipment.value}}</label>
                </div>

            </div>
        </div>
    </div>
    <div class="product-buttons mb-4">
        <button class="btn" type="submit">
            <div class="d-flex align-items-center gap-sm-2 gap-1">Guardar y continuar
                <app-common-svg-icons [icons]="'front-arrow'"></app-common-svg-icons>
            </div>
        </button>
    </div>
</form>